
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seo/seo-form",
      function () {
        return require("private-next-pages/seo/seo-form/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seo/seo-form"])
      });
    }
  